/**
 * Console Logger Utility
 * Provides conditional logging based on global settings
 */

let showConsoleLogs = false; // Default to false, will be updated by AuthContext

/**
 * Updates the logging state based on global settings
 * @param {boolean} enabled - Whether logging is enabled
 */
export const setLoggingEnabled = (enabled) => {
  showConsoleLogs = enabled;
};

/**
 * Gets the current logging state
 * @returns {boolean} Whether logging is enabled
 */
export const isLoggingEnabled = () => showConsoleLogs;

/**
 * Conditional console.log that respects global settings
 * @param {...any} args - Arguments to log
 */
export const conditionalLog = (...args) => {
  if (showConsoleLogs) {
    console.log(...args);
  }
};

/**
 * Conditional console.info that respects global settings
 * @param {...any} args - Arguments to log
 */
export const conditionalInfo = (...args) => {
  if (showConsoleLogs) {
    console.info(...args);
  }
};

/**
 * Conditional console.warn that respects global settings
 * @param {...any} args - Arguments to log
 */
export const conditionalWarn = (...args) => {
  if (showConsoleLogs) {
    console.warn(...args);
  }
};

// Always allow errors through regardless of setting
export const conditionalError = (...args) => {
  console.error(...args);
};

// Make it available globally for easy access
if (typeof window !== 'undefined') {
  window.debugLogs = {
    setEnabled: setLoggingEnabled,
    isEnabled: isLoggingEnabled
  };
}